import _ from "lodash";
import i18n from "i18next";

export const roundQuantity = (quantity, nbOfDecimal = 1) => {
  const float = parseFloat(quantity).toFixed(nbOfDecimal);
  return Number(float).toLocaleString(localStorage.getItem("language") || i18n.language);
};

export const formatQuantityValue = (quantity, forcedNbOfDecimal = undefined, emptyValue = "-") => {
  if (_.isEmpty(quantity) || !quantity.value || !quantity.unitOfMeasurement) {
    return emptyValue;
  }

  if (isNaN(parseFloat(quantity.value)) || parseFloat(quantity.value) === 0) {
    return emptyValue;
  }

  if (!isNaN(forcedNbOfDecimal)) {
    return `${roundQuantity(quantity.value, forcedNbOfDecimal)} ${quantity.unitOfMeasurement}`;
  }

  let nbOfDecimal = 1;
  if (_.includes(["RL", "ROLLS", "KG", "LBS", "M", "ME", "FT"], _.toUpper(quantity.unitOfMeasurement))) nbOfDecimal = 0;
  if (_.includes(["MSF", "MSI", "CSM"], _.toUpper(quantity.unitOfMeasurement))) nbOfDecimal = 4;

  return `${roundQuantity(quantity.value, nbOfDecimal)} ${quantity.unitOfMeasurement}`;
};

export const formatDimension = dimension => {
  if (_.isEmpty(dimension)) {
    return "-";
  }

  const { width = "", unitOfMeasurement = "", diameter = "" } = dimension;
  return `W ${width} ${unitOfMeasurement || ""} D ${diameter} ${unitOfMeasurement || ""}`;
};

export const parseFloatValue = value => (isNaN(parseFloat(value)) ? 0 : parseFloat(value));



// WEBPACK FOOTER //
// ./src/helpers/unitOfMeasurementHelpers.js